(function registerMoneyInput(scope) {
  const CURRENCY_TOKEN = /(?:NOK|SEK|DKK|EUR|USD|GBP|CHF|kr\.?(?:oner)?|kroner|euro|dollars?|£|\$|€)/gi;
  const SPACE_OR_GROUP_MARK = /[\s\u00a0\u202f'’]/g;

  const analyze = (value, { allowPartial = false, preferDecimal = false } = {}) => {
    if (typeof value === 'number') {
      return Number.isFinite(value)
        ? { value, canonical: String(value), editable: String(value), decimalSeparator: '' }
        : null;
    }

    const original = String(value ?? '').trim();
    if (!original) return allowPartial ? { value: null, canonical: '', editable: '', decimalSeparator: '' } : null;

    let text = original.replace(/[−–—]/g, '-');
    let negative = /^\(.*\)$/.test(text);
    if (negative) text = text.slice(1, -1).trim();
    text = text.replace(CURRENCY_TOKEN, '').replace(/%/g, '').trim();

    // "10 000,-" has zero decimals, not a trailing minus sign.
    const zeroDecimalSuffix = /[,.]-\s*$/.test(text);
    if (zeroDecimalSuffix) text = text.replace(/-\s*$/, '00');
    else if (/-\s*$/.test(text)) {
      negative = true;
      text = text.replace(/-\s*$/, '');
    }

    text = text.replace(SPACE_OR_GROUP_MARK, '').trim();

    if (text.startsWith('-')) {
      negative = true;
      text = text.slice(1);
    } else if (text.startsWith('+')) text = text.slice(1);

    if (allowPartial && !text) {
      const editable = negative ? '-' : '';
      return { value: null, canonical: editable, editable, decimalSeparator: '' };
    }
    if (!/^\d+(?:[.,]\d*)*$/.test(text)) return null;

    const dots = (text.match(/\./g) || []).length;
    const commas = (text.match(/,/g) || []).length;
    let decimal = '';
    let whole = text;
    let fraction = '';

    if (dots && commas) {
      decimal = text.lastIndexOf(',') > text.lastIndexOf('.') ? ',' : '.';
    } else if (dots || commas) {
      const separator = dots ? '.' : ',';
      const parts = text.split(separator);
      const trailingLength = parts[parts.length - 1].length;
      if (trailingLength === 0 || trailingLength <= 2 || (preferDecimal && parts.length === 2)) decimal = separator;
      else if (parts.length > 2 && trailingLength !== 3) return null;
    }

    if (decimal) {
      const decimalIndex = text.lastIndexOf(decimal);
      whole = text.slice(0, decimalIndex).replace(/[.,]/g, '');
      fraction = text.slice(decimalIndex + 1).replace(/[.,]/g, '');
    } else whole = text.replace(/[.,]/g, '');

    if (!whole || !/^\d+$/.test(whole) || (fraction && !/^\d+$/.test(fraction))) return null;
    const canonicalUnsigned = whole + (decimal ? `.${fraction}` : '');
    if (allowPartial && decimal && !fraction) {
      const canonical = `${negative ? '-' : ''}${whole}.`;
      return { value: Number(`${negative ? '-' : ''}${whole}`), canonical, editable: `${negative ? '-' : ''}${whole}${decimal}`, decimalSeparator: decimal };
    }

    const parsed = Number(`${negative ? '-' : ''}${canonicalUnsigned}`);
    if (!Number.isFinite(parsed)) return null;
    const editable = `${negative ? '-' : ''}${whole}${decimal ? decimal + fraction : ''}`;
    return { value: parsed, canonical: `${negative ? '-' : ''}${canonicalUnsigned}`, editable, decimalSeparator: decimal };
  };

  const parse = (value, options = {}) => analyze(value, options)?.value ?? null;
  const number = (value, fallback = 0) => {
    const parsed = analyze(value, { preferDecimal: true })?.value;
    return parsed == null ? fallback : parsed;
  };
  const normalizeEditable = (value, options = {}) => {
    const maxDecimals = Number(options.maxDecimals ?? 3);
    const simpleDecimal = String(value ?? '').trim().match(/^([+-]?\d+)([,.])(\d+)$/);
    const previous = analyze(options.previousValue, { allowPartial: true });
    // Prefer decimals while typing; pasted amounts still infer grouping.
    if (simpleDecimal && simpleDecimal[3].length > maxDecimals && (options.preferDecimal || previous?.decimalSeparator === simpleDecimal[2])) {
      return `${simpleDecimal[1]}${simpleDecimal[2]}${simpleDecimal[3].slice(0, maxDecimals)}`;
    }
    const analyzed = analyze(value, { allowPartial: true, preferDecimal: options.preferDecimal !== false });
    if (!analyzed) return String(value ?? '');
    if (!Number.isInteger(maxDecimals) || maxDecimals < 0 || !analyzed.decimalSeparator) return analyzed.editable;
    const separatorIndex = analyzed.editable.lastIndexOf(analyzed.decimalSeparator);
    return analyzed.editable.slice(0, separatorIndex + 1) + analyzed.editable.slice(separatorIndex + 1, separatorIndex + 1 + maxDecimals);
  };

  scope.PlummeMoneyInput = { analyze, parse, number, normalizeEditable };
})(typeof window !== 'undefined' ? window : globalThis);
